// Desconto de tarifa/bandeira: o banco guarda FRAÇÃO (0.28 = 28%) em `faturas` e
// `unidades_consumidoras`, e `calcularValoresBoleto` conta com fração. Só a tela do
// analista fala em percentual — esta é a fronteira entre os dois.
//
// Nas UCs, todo desconto é 0 ou vai de 12% a 100% (levantamento de 21/09/2026). Um
// valor entre 0 e 1 digitado no campo em % é o hábito do formato antigo (0,28 para
// 28%): aceitar faria o boleto sair quase sem desconto, e o auto-save do cálculo
// grava o desconto também na UC. Por isso é recusado, não convertido em silêncio.

export type LeituraPercentual =
  | { tipo: 'vazio' }
  | { tipo: 'ok'; fracao: number }
  | { tipo: 'erro'; mensagem: string };

/** 0.28 → "28"; 0.4999 → "49,99". */
export function fracaoParaPercentTexto(fracao: number | null | undefined): string {
  if (fracao === null || fracao === undefined || !Number.isFinite(Number(fracao))) return '';
  const percent = Math.round(Number(fracao) * 10000) / 100;
  return percent.toLocaleString('pt-BR', { maximumFractionDigits: 2, useGrouping: false });
}

/** Lê o que o analista digitou em % (vírgula ou ponto) e devolve a fração para o banco. */
export function lerPercentDigitado(texto: string): LeituraPercentual {
  const limpo = texto.replace(/[%\s]/g, '').replace(',', '.');
  if (limpo === '' || limpo === '.') return { tipo: 'vazio' };
  // Separador no fim ("28,") é digitação em andamento: vale como 28.
  if (!/^\d+(\.\d*)?$/.test(limpo)) return { tipo: 'erro', mensagem: 'Digite só o número, ex.: 28 ou 28,5.' };
  const percent = Number(limpo);
  // Antes das casas decimais: "0,4999" é o formato antigo, não excesso de casas.
  if (percent > 0 && percent < 1) {
    const emPercent = fracaoParaPercentTexto(percent);
    return { tipo: 'erro', mensagem: `O campo agora é em %: para ${emPercent}%, digite ${emPercent} (não ${limpo.replace('.', ',')}).` };
  }
  const [, decimais = ''] = limpo.split('.');
  if (decimais.length > 2) return { tipo: 'erro', mensagem: 'Use no máximo 2 casas decimais.' };
  if (percent > 100) return { tipo: 'erro', mensagem: 'O desconto vai de 0 a 100%.' };
  return { tipo: 'ok', fracao: Math.round(percent * 100) / 10000 };
}
